export default "__VITE_ASSET__Dln_FUNL__"